export default "__VITE_ASSET__D4XsA7FM__"